/* TestRunPanel — Dry-run results display */
import css from '../AutomationEditor.module.css';
import type { TestRunResult } from '../../../types/automations';

interface Props {
  result: TestRunResult | null;
  isRunning: boolean;
  onRun: () => void;
  onClose: () => void;
}

const STATUS_COLORS: Record<string, string> = {
  completed: '#22c55e',
  failed: '#ef4444',
  skipped: '#94a3b8',
};

export default function TestRunPanel({ result, isRunning, onRun, onClose }: Props) {
  return (
    <div className={css.testRunPanel}>
      <div className={css.testRunHeader}>
        <span>Test Run</span>
        <div className={css.testRunActions}>
          <button className={css.testRunBtn} onClick={onRun} disabled={isRunning}>
            {isRunning ? 'Running...' : '▶ Run Test'}
          </button>
          <button className={css.testRunClose} onClick={onClose}>
            ✕
          </button>
        </div>
      </div>

      {!result && !isRunning && (
        <div className={css.testRunEmpty}>
          Click "Run Test" to simulate this automation with mock data. No real actions will be
          performed.
        </div>
      )}

      {result && (
        <div className={css.testRunBody}>
          {result.error && <div className={css.historyError}>{result.error}</div>}
          {result.note && <div className={css.testRunNote}>{result.note}</div>}

          {result.steps.map((step, i) => (
            <div key={i} className={css.testRunStep}>
              <div className={css.testRunStepHeader}>
                <span
                  className={css.historyStatusDot}
                  style={{ background: STATUS_COLORS[step.status] }}
                />
                <span className={css.testRunStepName}>{step.node_label || step.node_def_key}</span>
                <span className={css.testRunStepCategory}>{step.category}</span>
                <span className={css.testRunStepStatus} data-status={step.status}>
                  {step.status}
                </span>
              </div>

              {step.error && <div className={css.historyError}>{step.error}</div>}

              {step.output && (
                <pre className={css.historyJson}>{JSON.stringify(step.output, null, 2)}</pre>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
